(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spotlight-slider"] && !Shopify.designMode) return;
  try {
    

/* --- Make sure to initialize only once --- */
function initSpotlightSlider() {
  var $slider = $('.spotlight-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 300,
    swipeToSlide: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.1,   // 1 full + slight peek
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: false,
          autoplay: true,
          swipeToSlide: true,
          variableWidth: false,
          centerMode: false,
          initialSlide: 0,
          speed: 350
        }
      }
    ]
  });

  // Force proper track alignment after every slide change
  $slider.on('afterChange', function (event, slick, currentSlide) {
    if (window.innerWidth <= 767) {
      const track = $slider.find('.slick-track');
      // remove Slick’s accidental transform reset
      const offset = currentSlide * $slider.find('.slick-slide').outerWidth(true) * -1;
      track.css('transform', `translate3d(${offset}px, 0, 0)`);
    }
  });
}

/* --- Initial load --- */
$(document).ready(function() {
  initSpotlightSlider();
});

/* --- Re-initialize after Shopify section re-render --- */
document.addEventListener('shopify:section:load', initSpotlightSlider);
document.addEventListener('shopify:section:reorder', initSpotlightSlider);
document.addEventListener('shopify:section:unload', function() {
  $('.spotlight-slider').slick('unslick');
});

  } catch(e) { console.error(e); }
})();
})();
